import {
  ComponentType,
  createContext,
  PropsWithChildren,
  useContext,
} from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import { FCC } from '../../../../utils/react';
import { FontFamily } from '../../../styles/Colors';
import { ButtonTextStyleProvider } from './ButtonText';

export interface ButtonVariantProps extends PropsWithChildren<unknown> {
  style?: StyleProp<ViewStyle>;
  disabled?: boolean;
  onPress?: () => void;
}

const DefaultButtonVariantContext =
  createContext<ComponentType<ButtonVariantProps>>(DefaultButtonVariant);

export const DefaultButtonVariantProvider: FCC<{
  ButtonVariant: ComponentType<ButtonVariantProps>;
}> = props => (
  <DefaultButtonVariantContext.Provider value={props.ButtonVariant}>
    {props.children}
  </DefaultButtonVariantContext.Provider>
);

export const useDefaultButtonVariant = (): ComponentType<ButtonVariantProps> =>
  useContext(DefaultButtonVariantContext);

function DefaultButtonVariant(props: ButtonVariantProps): JSX.Element {
  return (
    <ButtonTextStyleProvider
      style={FontFamily.boldFlattened({
        fontSize: 14,
        letterSpacing: -0.34,
        lineHeight: 22,
      })}
    >
      <TouchableOpacity
        css={{
          height: 50,
          borderRadius: 25,
          minWidth: 80,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 35,
          paddingRight: 35,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        style={props.style}
        onPress={props.onPress}
        disabled={props.disabled}
      >
        {props.children}
      </TouchableOpacity>
    </ButtonTextStyleProvider>
  );
}
